var _path, _circle, _path2, _circle2, _circle3, _circle4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOptimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 536,
    viewBox: "0 0 1920 536",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.735 384.262C187.115 384.262 207.977 400 222.616 400C237.255 400 268 391.58 268 324.231C268 256.883 226.639 247 210.538 247C135.139 247 102.931 384.262 156.735 384.262Z",
    fill: "url(#paint0_linear_4596_14789)",
    fillOpacity: 0.15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 281,
    r: 11,
    fill: "url(#paint1_linear_4596_14789)",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1641.35 474.64C1659.28 474.64 1671.59 484 1680.22 484C1688.86 484 1707 478.992 1707 438.935C1707 398.878 1682.6 393 1673.1 393C1628.61 393 1609.61 474.64 1641.35 474.64Z",
    fill: "url(#paint2_linear_4596_14789)",
    fillOpacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1600,
    cy: 427,
    r: 11,
    fill: "url(#paint3_linear_4596_14789)",
    fillOpacity: 0.15
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 81,
    r: 21,
    fill: "url(#paint4_linear_4596_14789)",
    fillOpacity: 0.15
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1796,
    cy: 255,
    r: 18,
    fill: "url(#paint5_linear_4596_14789)",
    fillOpacity: 0.15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4596_14789",
    x1: 150.7,
    y1: 252.1,
    x2: 281.785,
    y2: 386.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4596_14789",
    x1: 71.3,
    y1: 270.733,
    x2: 90,
    y2: 292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4596_14789",
    x1: 1637.79,
    y1: 396.033,
    x2: 1715.77,
    y2: 475.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4596_14789",
    x1: 1592.3,
    y1: 416.733,
    x2: 1611,
    y2: 438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4596_14789",
    x1: 205.3,
    y1: 61.4,
    x2: 241,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4596_14789",
    x1: 1783.4,
    y1: 238.2,
    x2: 1814,
    y2: 273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimize);
export default __webpack_public_path__ + "static/media/optimize.c0ceb8aa1431243c2dfeeb89400ede66.svg";
export { ForwardRef as ReactComponent };